import { IAccessibilityManagerContentHandler } from '@src/slide/application/service/accessibility-manager/core/accessibility-manager.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

export interface IElementBaseAccessibilityContent {
    getAccessibilityContent(isSelected?: boolean, content?: string): string
}

export class ElementBaseAccessibilityContent implements IElementBaseAccessibilityContent {
    private model: IElementBaseModel;
    public constructor(model: IElementBaseModel, protected a11yManager: IAccessibilityManagerContentHandler) {
        this.model = model;
    }

    public getAccessibilityContent(isSelected = false, content = ''): string {
        return content;
    }
}
